import { useFormContext } from 'react-hook-form';

import { useAppSelector } from '@/Application/Hooks/Redux';
import type { GiftCardFormFields } from '@/modules/cart/domain/Cart';
import { CardButton } from '@/modules/perseo-billing/components';

interface IAddGiftCardFormFooterProps {
  handleSubmit: () => void;
}

export const AddGiftCardFormFooter = ({
  handleSubmit
}: IAddGiftCardFormFooterProps) => {
  const { isLoading } = useAppSelector((state) => state.cart);

  const giftCardForm = useFormContext<GiftCardFormFields>();
  const isValid = giftCardForm?.formState?.isValid;

  return (
    <div className="co-flex co-justify-between co-items-center co-gap-4">
      <div className="co-flex co-flex-grow lg:co-flex-grow-0 lg:co-min-w-310px">
        <CardButton
          pl={24}
          pr={24}
          fullWidth
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={!isValid}
          loading={isLoading}
          type="submit"
        >
          Agregar
        </CardButton>
      </div>
    </div>
  );
};
